<template>
  <InviteTeammatesForm>
    <template #progress-bar>
      <CompleteSignupProgressAtlassian :currentStep="2" />
    </template>
  </InviteTeammatesForm>
</template>

<script>
import { isConfirmTokenPresent, showSessionExpiredWarning } from '@utils/confirmationToken'
import InviteTeammatesForm from '@components/sign-up/InviteTeammatesForm.vue'
import CompleteSignupProgressAtlassian from '@components/sign-up/complete-signup-progress/CompleteSignupProgressAtlassian.vue'

export default {
  name: 'InviteTeammatesAtlassian',
  components: {
    InviteTeammatesForm,
    CompleteSignupProgressAtlassian
  },
  mounted () {
    // Show warning message on page load if no confirmation cookie
    if (!isConfirmTokenPresent(this.$cookies)) {
      showSessionExpiredWarning(this)
    }
  }
}
</script>
